export const ADMIN_CHAT_USERS_REQUEST = "ADMIN_CHAT_USERS_REQUEST";
export const ADMIN_CHAT_USERS_SUCCESS = "ADMIN_CHAT_USERS_SUCCESS";
export const ADMIN_CHAT_USERS_FAIL = "ADMIN_CHAT_USERS_FAIL";

export const ADMIN_CHAT_SEND_REQUEST = "ADMIN_CHAT_SEND_REQUEST";
export const ADMIN_CHAT_SEND_SUCCESS = "ADMIN_CHAT_SEND_SUCCESS";
export const ADMIN_CHAT_SEND_FAIL = "ADMIN_CHAT_SEND_FAIL";

export const ADMIN_CHAT_RECEIVE_REQUEST = "ADMIN_CHAT_RECEIVE_REQUEST";
export const ADMIN_CHAT_RECEIVE_SUCCESS = "ADMIN_CHAT_RECEIVE_SUCCESS";
export const ADMIN_CHAT_RECEIVE_FAIL = "ADMIN_CHAT_RECEIVE_FAIL";
